import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import CopyButton from '../shared/CopyButton';
import Mixpanel from '../shared/Mixpanel';
import './PixelRow.css';

const PixelRow = ({ creativeData, createPixel, pixelUrl }) => {
  const createPixelForCreative = () => {
    Mixpanel.track('Created 2.3 Pixel', { creativeId: creativeData.id });
    return createPixel(creativeData.id);
  };

  const trackCopyClick = () => {
    Mixpanel.track('Copied Pixel URL', { creativeId: creativeData.id });
  };

  return (
    <div className="pixel-row creative-tag-area p2 mb2 mt1">
      <span className="creative-title">{creativeData.name}</span>
      {pixelUrl ? (
        <Fragment>
          <span className="pixel-row_pixel-url">{pixelUrl}</span>
          <CopyButton copyContent={pixelUrl} onClick={trackCopyClick} />
        </Fragment>
      ) : (
        <Fragment>
          <button
            data-testid="generate-pixel-button"
            type="button"
            className="copy-button btn btn-primary"
            onClick={createPixelForCreative}
          >
            Generate Pixel
          </button>
        </Fragment>
      )}
    </div>
  );
};

PixelRow.propTypes = {
  creativeData: PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired
  }).isRequired,
  createPixel: PropTypes.func.isRequired,
  pixelUrl: PropTypes.string
};

PixelRow.defaultProps = {
  pixelUrl: null
};

export default PixelRow;
